module.exports = "https://cdn.thelire.com/ins/resource/pic_suppay_rating@3x.38c8fe73bd7139c10d8662a7a7f2b73f.png";